"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.get_OPTIONS_BY_WHOAMI_AND_NAME = exports.END_OPTIONS_BY_WHOAMI_AND_NAME = void 0;
var _startEndRules = require("../types/start-end-rules");
// import { IRF_AIR_VAL } from "@robotical/ricjs-robotical-addons/dist/RICRoboticalAddOns";

const get_OPTIONS_BY_WHOAMI_AND_NAME = (rule, whoAmI, addonInputName) => {
  const options = rule === "start" ? START_OPTIONS_BY_WHOAMI_AND_NAME : END_OPTIONS_BY_WHOAMI_AND_NAME;
  try {
    return options[whoAmI][addonInputName] || [];
  } catch (e1) {
    // trying removing the last char of the whoAmI in case it's a dubplicate addon and so last char == number
    const l = whoAmI.length;
    try {
      return options[whoAmI.slice(0, l - 1)][addonInputName] || [];
    } catch (e) {
      console.log("No specific ".concat(rule, " options for"), whoAmI, addonInputName);
      return [];
    }
  }
};
exports.get_OPTIONS_BY_WHOAMI_AND_NAME = get_OPTIONS_BY_WHOAMI_AND_NAME;
const START_OPTIONS_BY_WHOAMI_AND_NAME = {
  IRFoot: {
    Val: [{
      ruleStr: _startEndRules.IRFOOT_VAL_BIGGER_THAN_20,
      ruleFunc: val => val > 20
    }]
  },
  Accelerometer: {
    x: [{
      ruleStr: _startEndRules.ACCELEROMETER_X_BIGGERN_THAN_20,
      ruleFunc: val => val > 20
    }],
    y: [{
      ruleStr: _startEndRules.ACCELEROMETER_Y_BIGGERN_THAN_20,
      ruleFunc: val => val > 20
    }],
    z: [{
      ruleStr: _startEndRules.ACCELEROMETER_Z_BIGGERN_THAN_20,
      ruleFunc: val => val > 20
    }]
  },
  Magnetometer: {
    x: [{
      ruleStr: _startEndRules.MAGNETOMETER_X_BIGGERN_THAN_20,
      ruleFunc: val => val > 20
    }],
    y: [{
      ruleStr: _startEndRules.MAGNETOMETER_Y_BIGGERN_THAN_20,
      ruleFunc: val => val > 20
    }],
    z: [{
      ruleStr: _startEndRules.MAGNETOMETER_Z_BIGGERN_THAN_20,
      ruleFunc: val => val > 20
    }]
  },
  coloursensor: {
    Red: [{
      ruleStr: _startEndRules.COLOR_SENSOR_RED_BIGGER_THAN_100,
      ruleFunc: val => val > 100
    }],
    Green: [{
      ruleStr: _startEndRules.COLOR_SENSOR_GREEN_BIGGER_THAN_100,
      ruleFunc: val => val > 100
    }],
    Blue: [{
      ruleStr: _startEndRules.COLOR_SENSOR_BLUE_BIGGER_THAN_100,
      ruleFunc: val => val > 100
    }]
  },
  lightsensor: {
    Reading1: [{
      ruleStr: _startEndRules.LIGHT_SENSOR_R1_BIGGERN_THAN_20,
      ruleFunc: val => val > 20
    }],
    Reading2: [{
      ruleStr: _startEndRules.LIGHT_SENSOR_R2_BIGGERN_THAN_20,
      ruleFunc: val => val > 20
    }],
    Reading3: [{
      ruleStr: _startEndRules.LIGHT_SENSOR_R3_BIGGERN_THAN_20,
      ruleFunc: val => val > 20
    }]
  }
};
const END_OPTIONS_BY_WHOAMI_AND_NAME = exports.END_OPTIONS_BY_WHOAMI_AND_NAME = {};